<div style="box-sizing: border-box; display: flex; flex: 1 1 0%; flex-direction: row; place-content: stretch center; align-items: stretch; height:100%">
  <div style="flex-direction: column; box-sizing: border-box; display: flex; place-content: stretch flex-start; align-items: stretch; flex: 1 1 100%; max-width: 50%;">
    <div style="flex: 1 1 100%; box-sizing: border-box; max-height: 5%">
    </div>
    <div style="box-sizing: border-box; display: flex; flex: 1 1 0%; flex-direction: column">
      <mat-toolbar color="primary">
        <mat-card-title style="place-content: center space-between; align-items: center; flex-direction: row; box-sizing: border-box; display: flex; width:100%">
          <div>
            User Profile Information
          </div>
        </mat-card-title>
      </mat-toolbar>
      <div *ngIf="userProfileForm" style="overflow-y: auto; flex: 1 1 0%; box-sizing: border-box;">
        <mat-card appearance="outlined">
          <mat-card-content>
            <form [formGroup]="userProfileForm" novalidate (ngSubmit)="onSubmit()">
              <div>
                <div class="row" style="flex-direction: row; box-sizing: border-box; display: flex;">
                  <div style="flex: 1 1 0%; box-sizing: border-box;">
                    <div *ngIf="!inEdit" class="cell">
                      <div class="title">Salutation</div>
                      <div>{{userProfile.salutation}}</div>
                    </div>
                    <mat-form-field *ngIf="inEdit">
                      <mat-label>Salutation</mat-label>
                      <mat-select matInput formControlName="salutation">
                        <mat-option *ngFor="let s of salutations" [value]="s.displayName">
                          {{s.displayName}}
                        </mat-option>
                      </mat-select>
                    </mat-form-field>
                  </div>
                </div>
              </div>
              <div>
                <div class="row" style="box-sizing: border-box; display: flex; flex: 1 1 0%; flex-direction: row; gap: 20px;">
                  <div style="flex: 1 1 0%; box-sizing: border-box;">
                    <div *ngIf="!inEdit" class="cell">
                      <div class="title">First Name</div>
                      <div>{{userProfile.firstName}}</div>
                    </div>
                    <mat-form-field *ngIf="inEdit" class="full-width">
                      <input matInput placeholder="First Name" formControlName="firstName">
                      <mat-error *ngIf="userProfileForm.controls['firstName'].invalid && (userProfileForm.controls['firstName'].touched || userProfileForm.controls['firstName'].dirty)">
                        <p *ngIf="userProfileForm.controls['firstName'].errors.empty">First Name is <strong>required</strong></p>
                        <p *ngIf="userProfileForm.controls['firstName'].errors.maxlength">First Name can not exceed <strong>256</strong> characters.</p>
                      </mat-error>
                    </mat-form-field>
                  </div>
                  <div style="flex: 1 1 0%; box-sizing: border-box;">
                    <div *ngIf="!inEdit" class="cell">
                      <div class="title">Last Name</div>
                      <div>{{userProfile.lastName}}</div>
                    </div>
                    <mat-form-field *ngIf="inEdit" class="full-width">
                      <input matInput placeholder="Last Name" formControlName="lastName">
                      <mat-error *ngIf="userProfileForm.controls['lastName'].invalid && (userProfileForm.controls['lastName'].touched || userProfileForm.controls['lastName'].dirty)">
                        <p *ngIf="userProfileForm.controls['lastName'].errors.empty">Last Name is <strong>required</strong></p>
                        <p *ngIf="userProfileForm.controls['lastName'].errors.maxlength">Last Name can not exceed <strong>256</strong> characters.</p>
                      </mat-error>
                    </mat-form-field>
                  </div>
                </div>
              </div>
              <div class="row" style="flex-direction: row; box-sizing: border-box; display: flex;">
                <div style="flex: 1 1 0%; box-sizing: border-box;">
                  <div *ngIf="!inEdit" class="cell">
                    <div class="title">Organization Name</div>
                    <div>{{userProfile.organization}}</div>
                  </div>
                  <mat-form-field *ngIf="inEdit" class="full-width">
                    <input matInput placeholder="Organization Name" formControlName="organization">
                    <mat-error *ngIf="userProfileForm.controls['organization'].invalid && (userProfileForm.controls['organization'].touched || userProfileForm.controls['organization'].dirty)">
                      <p *ngIf="userProfileForm.controls['organization'].errors.maxlength">Organization Name can not exceed <strong>256</strong> characters.</p>
                    </mat-error>
                  </mat-form-field>
                </div>
              </div>
            </form>
          </mat-card-content>
          <mat-card-actions>
            <div style="box-sizing: border-box; display: flex; flex: 1 1 0%; place-content: center flex-end; align-items: center;">
              <button *ngIf="!inEdit" id="edit" mat-raised-button color="primary" type="button" (click)="onEdit()">Edit</button>
              <button *ngIf="inEdit" id="update" mat-raised-button color="primary" type="submit" (click)="onSubmit()">Update</button>
              <button *ngIf="inEdit" id="cancel" mat-button color="secondary" type="button" (click)="onCancel()">Cancel</button>
            </div>
          </mat-card-actions>
        </mat-card>
      </div>
    </div>
    <div style="flex: 1 1 100%; box-sizing: border-box; max-height: 5%">
    </div>
  </div>
</div>
